interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
}

export default function SectionHeading({ eyebrow, title, desc, align = "center" }: Props) {
  return (
    <div className={align === "center" ? "text-center" : "text-left"}>
      <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
        <i className="ri-flower-line" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-900 md:text-3xl">{title}</h2>
      {desc && <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}